import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-kaupsagan',
  templateUrl: './about-kaupsagan.component.html',
  styleUrls: ['./about-kaupsagan.component.scss']
})
export class AboutKaupsaganComponent implements OnInit {

  environment = environment;

  constructor() { }

  ngOnInit(): void {
  }
}
